import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";

const Table1 = ({ setselected_item_data }) => {
  const [errorMessage, seterrorMessage] = useState("");
  const [errorType, seterrorType] = useState("Error");
  const [isErrorVisible, setisErrorVisible] = useState(false);
  // Create initial row data structure
  const createNewRow = () => ({
    CostCenter: "",
    Percentage: "",
  });
  const staticCompany = [
    { id: 1, name: "Stackerbee" },
    { id: 2, name: "Google" },
    { id: 3, name: "Microsoft" },
  ];
  const [CompanyList, setCompanyList] = useState([staticCompany]);

  // Refs and state management
  const tableRef = useRef(null);
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [focusedCell, setFocusedCell] = useState({
    rowIndex: null,
    field: null,
  });

  // Pagination values
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  // Select all rows handler
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  // Update row data — use keys without spaces
  const updateRow = (index, field, value) => {
    // console.log(index, field, value);
    const updatedRows = [...rows];
    updatedRows[index] = { ...updatedRows[index], [field]: value };

    // if you had an is_primary logic, keep it; left as-is for now
    if (field === "is_primary" && value === true) {
      updatedRows.forEach((row, i) => {
        if (i !== index) row.is_primary = false;
      });
    }

    setRows(updatedRows);
    if (typeof setselected_item_data === "function") {
      setselected_item_data(updatedRows);
    }
  };

  // Toggle row selection
  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // Add new row
  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    if (typeof setselected_item_data === "function")
      setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    setCurrentPage(lastPage);
  };

  // Delete selected rows
  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    if (typeof setselected_item_data === "function")
      setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.max(1, Math.ceil(updatedRows.length / rowsPerPage));
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };

  // Column resizer setup with cleanup
  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    if (!cols || cols.length === 0) return;

    const resizers = [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      // optional base styles for resizer
      resizer.style.position = "absolute";
      resizer.style.right = "0";
      resizer.style.top = "0";
      resizer.style.height = "100%";
      resizer.style.width = "8px";
      resizer.style.cursor = "col-resize";
      resizer.style.userSelect = "none";
      col.style.position = "relative";
      col.appendChild(resizer);
      resizers.push({ col, resizer });

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        e.preventDefault();
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        const newWidth = Math.max(40, w + dx);
        col.style.width = `${newWidth}px`;
        col.style.minWidth = `${newWidth}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);

      // store handlers so we can remove on cleanup
      resizer._cleanup = () => {
        resizer.removeEventListener("mousedown", onMouseDown);
      };
    });

    return () => {
      // cleanup resizers
      resizers.forEach(({ col, resizer }) => {
        if (resizer._cleanup) resizer._cleanup();
        if (col.contains(resizer)) col.removeChild(resizer);
      });
    };
  }, []);
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Cost Center",
              "Percentage (%)",
              "Settings",
            ].map((title, i) => {
              const defaultWidths = {
                Action: "40px",
                "S.No": "40px",
                "Cost Center": "280px",
                "Percentage (%)": "280px",
                Settings: "80px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: "12px",
                    position: "relative",
                    textAlign:
                      title === "Action" ||
                      title === "S.No" ||
                      title === "Settings"
                        ? "center"
                        : "left",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Settings" ? (
                    <GetIcon iconName="IoSettingsOutline" size={15} />
                  ) : title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                {/* Action (Checkbox) */}
                <td
                  className="pt-2"
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <input
                      type="checkbox"
                      className=""
                      checked={selectedRows.includes(globalIndex)}
                      onChange={() => toggleRowSelection(globalIndex)}
                    />
                  </div>
                </td>

                {/* S.No */}
                <td style={{ textAlign: "center", fontSize: "0.9rem" }}>
                  {globalIndex + 1}
                </td>

                {/* Party */}

                {/* PostingDate */}
                <td
                  className="p-1"
                  style={{
                    border:
                      focusedCell.rowIndex === globalIndex &&
                      focusedCell.field === "CostCenter"
                        ? "0.3px solid #270b79"
                        : "",
                  }}
                >
                  <select
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem" }}
                    onFocus={() =>
                      setFocusedCell({
                        rowIndex: globalIndex,
                        field: "CostCenter",
                      })
                    }
                    onBlur={() =>
                      setFocusedCell({ rowIndex: null, field: null })
                    }
                    value={row.CostCenter || ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "CostCenter", e.target.value)
                    }
                  >
                    <option value="">Select Date</option>
                    <option value="MAN LAD">MAN LAD</option>
                    <option value="MAN AAD">MAN AAD</option>
                    <option value="MAN MAD">MAN MAD</option>
                  </select>
                </td>
                <td
                  className="p-0"
                  style={{
                    border:
                      focusedCell.rowIndex === globalIndex &&
                      focusedCell.field === "Percentage"
                        ? "0.3px solid #270b79"
                        : "",
                  }}
                >
                  <input
                    type="text"
                    name="NewExchangeRate"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem" }}
                    placeholder=""
                    onFocus={() =>
                      setFocusedCell({
                        rowIndex: globalIndex,
                        field: "Percentage",
                      })
                    }
                    onBlur={() =>
                      setFocusedCell({ rowIndex: null, field: null })
                    }
                    value={row.Percentage || ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "Percentage", e.target.value)
                    }
                  />
                </td>

               

                {/* Settings (Edit icon) */}
                <td className="p-0" style={{ height: "30px" }}>
                  <span
                    style={{ position: "relative", top: "4px", height: "30px" }}
                    onClick={() => setShowPaymentModal(true)}
                  >
                    <GetIcon iconName="MdOutlineEdit" size={15} />
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Table controls */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: "4px" }}>
          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}

          <Button
            onClick={handleAddRow}
            className="Addrowdesign"
            iconName="FiPlus"
            iconSize={12}
            iconWrapperStyle={{
              backgroundColor: "#F6D593",
              padding: "1px",
              display: "flex",
            }}
          >
            Add Row
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Download
          </Button>
        </div>

        {/* Pagination */}
        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default Table1;
